<template>
  <el-menu class="navbar" mode="horizontal">
    <!--    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>-->
    <!--    <breadcrumb></breadcrumb>-->
    <el-row class="margin-auto-top" :gutter="12">
      <!-- 子代才显现头像和昵称 -->
      <el-col v-if="$store.getters.userinfo.agency_type == 1" :span="5" style="min-width: 250px;">
        <div class="user-photo">
          <img :src="$store.state.user.userinfo.avatar" width="80px" height="80px" />
        </div>
        <!-- <div style="width:180px;margin-left:80px;" v-if="$store.getters.userinfo.agency_type === 2">{{$store.state.user.userinfo.nickname}}</div> -->
        <div v-if="$store.getters.userinfo.agency_type === 1" class="user-userinfo-div1">
          <div style="width:180px;" class="user-nickname">{{$store.state.user.userinfo.nickname}}</div>

          <div v-if="this.$store.state.user.userinfo.working" class="user-working">
            <el-button type="success" class="min-work" @click="togWorking(false)">休息</el-button>
            <el-button type="danger" class="min-work">上班中</el-button>
          </div>
          <div v-else class="user-working">
            <el-button type="danger" class="min-work">休息中</el-button>
            <el-button type="success" class="min-work" @click="togWorking(true)">上班</el-button>
          </div>
        </div>
      </el-col>
      <el-col :span="$store.getters.userinfo.agency_type == 1?12:24" class="user-wechat">
        <div class="text-left">
          <span v-if="$store.getters.userinfo.agency_type === 1">
            可用收款账号：
            <span style="color:red;">{{$store.state.user.userinfo.receipt_address_count}}</span>
            <span class="title-span"></span>
          </span>
          <!-- 除了财务运营外的运营账号都不展示余额 -->
            <span v-if="!(this.$store.getters.userinfo.agency_type === 2 && (this.$store.getters.userinfo.role && this.$store.getters.userinfo.role !== 3))">余额：</span>
            <span v-if="!(this.$store.getters.userinfo.agency_type === 2 && (this.$store.getters.userinfo.role && this.$store.getters.userinfo.role !== 3))" style="color:red;">{{this.$store.state.user.userinfo.balance/100}}</span>&nbsp;&nbsp;
            <el-button v-if="!(this.$store.getters.userinfo.agency_type === 2 && (this.$store.getters.userinfo.role && this.$store.getters.userinfo.role !== 3))" type="success" class="min-work" @click="add">充值</el-button>
        </div>
        <div v-if="$store.getters.userinfo.agency_type === 1" class="center text-left">
          单笔最低金额：
          <span style="color:red;">{{ minAmount }}</span>
        </div>
        <div>
          <el-button class="bulletin" icon="el-icon-bell" circle></el-button>
          系统公告：{{bulletinTitle}}
        </div>
      </el-col>
      <el-col :span="4">
        <div class="service" v-if="$store.getters.userinfo.agency_type === 1">
          <el-badge
            :value="unMsgtotal || ' '"
            :max="10"
            class="item"
            :class="imStatus?shake:'workoff'"
            :type="imStatus?unMsgtotal?null:'success':'info'"
          >
            <el-button
              circle
              :type="imStatus?'danger':'info'"
              icon="el-icon-service"
              @click="openService(null)"
            ></el-button>
          </el-badge>
        </div>
        <el-dropdown class="avatar-container" trigger="click">
          <div class="avatar-wrapper">
            <i class="icon iconfont icon-mine" style="font-size: large"></i>
            <span class="user-avatar">{{name}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu class="user-dropdown" slot="dropdown">
            <el-dropdown-item @click.native="showUserSet=true">
              <i class="icon iconfont icon-setup" style="font-size: 16px"></i>&nbsp;修改密码
            </el-dropdown-item>
            <el-dropdown-item divided>
              <span @click="logout" style="display:block;">
                <i class="icon iconfont icon-guanbi1" style="font-size: 14px"></i>&nbsp;退出登录
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <user-set :showUserSet.sync="showUserSet"></user-set>
        <save-update
          v-if="showUpdate"
          :showUpdate.sync="showUpdate"
          :id="$store.state.user.userinfo.id"
        ></save-update>
        <div
          v-if="$store.state.user.userinfo.im_token && $store.getters.userinfo.agency_type === 1"
        >
          <div
            ref="iframeBox"
            style="width:400px;height:700px;"
            :class="fullheightclass"
            class="serviceIframe"
            v-show="showServiceIframe"
          >
            <div @click="isShowResize = true" class="drag" @mousedown="mousedown_move"></div>
            <i
              v-show="isShowResize"
              @mousedown="mousedown_resize($event,-1,true)"
              class="resize-icon resize-icon-top-left"
            ></i>
            <i
              v-show="isShowResize"
              @mousedown="mousedown_resize($event,1,true)"
              class="resize-icon resize-icon-top-right"
            ></i>
            <i
              v-show="isShowResize"
              @mousedown="mousedown_resize($event,1,false)"
              class="resize-icon resize-icon-bottom-left"
            ></i>
            <i
              v-show="isShowResize"
              @mousedown="mousedown_resize($event,1,false)"
              class="resize-icon resize-icon-bottom-right"
            ></i>
            <!-- 让鼠标一直是在当前窗口滑动，不进iframe窗口 -->
            <div
              v-show="isShowResize"
              style="position:absolute;height:100%;width:100%;z-index: 91011;background:transparent"
            ></div>
            <iframe
              ref="serviceIframe"
              id="serviceIframe"
              name="serviceIframe"
              @message="message(e)"
              frameborder="0"
              style="width:100%;height:100%;"
              :src="imUrl"
              marginwidth="0"
              marginheight="0"
              vspace="0"
              hspace="0"
              allowtransparency="true"
              scrolling="no"
              allowfullscreen="true"
            ></iframe>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-menu>
</template>

<script>
import { getImHost, getApiHost } from "@/utils/config";
import { mapGetters } from "vuex";
import saveUpdate from "@/views/agencyRecharge/saveUpdate";
// import Breadcrumb from '@/components/Breadcrumb'
// import Hamburger from '@/components/Hamburger'
import UserSet from "./UserSet";
import { gotoWork, gooffWork, getBulletin } from "@/api/index";
import { getToken } from '@/utils/auth'
//  import {useVcode} from "../../../utils/CommonJs";

export default {
  data() {
    return {
      version: {
        test: "1.8.14",
        production: "1.8.14"
      },
      ImHost: getImHost(),
      apiHost: getApiHost(),
      orderToken: getToken(),
      showUserSet: false,
      showServiceIframe: false,
      avatar: "",
      bulletin: "",
      bulletinTitle: "",
      bulletincount: 0,
      showUpdate: false,
      unreadyMsg: null,
      imStatus: true,
      unMsgtotal: null,
      outTimeFun: "",
      fullHeight: document.documentElement.clientHeight,
      fullheightclass: "",
      dialogArr: [],
      userMessageisopen: false,
      friendid: "",
      isfriend: false,
      shake: "",
      prevCid: null, //上一条消息的cid
      isMouseDown_move: false, // 移动
      isMouseDown_move_resize: false, // 缩放
      position: {
        // iframe位置
        x: null,
        y: null
      },
      coordinate: {
        // 坐标，用于移动
        curx: null,
        cury: null,
        prevx: null,
        prevy: null
      },
      isShowResize: false,
      size: {
        width: null,
        height: null
      },
      direction: 1, // 1或者-1
      resize_isX: true,
      time: null, //防抖
      updateUserInfoInterval: null
    };
  },
  created() {
    window.name = "test";
    window.addEventListener("message", this.handleMessage);
  },
  components: {
    // Breadcrumb,
    // Hamburger,
    UserSet,
    saveUpdate
  },
  computed: {
    ...mapGetters([
      "sidebar",
      "name",
      "imtoken",
      "imid",
      "is_operator_account"
    ]),
    minAmount() {
      const single_min_amount = this.$store.state.user.userinfo.single_min_amount / 100;
      return single_min_amount || '无限制'
    },
    imUrl() {
      let version;
      console.log("当前环境", process.env.NODE_ENV);
      switch (process.env.NODE_ENV) {
        case "production":
        case "foshan":
          version = this.version.production;
          break;
        default:
          version = this.version.test;
      }
      //${this.ImHost} //http://localhost:5500
      // return this.isfriend?`http://127.0.0.1:8848/newItpay-im/business/chat/player/playerMultiple.html?role=agent&token=${this.imtoken}&imid=${this.imid}${this.friendid}&v=${version}`:`http://127.0.0.1:8848/newItpay-im/business/chat/player/playerMultiple.html?role=agent&chatType=0&token=${this.imtoken}&imid=${this.imid}&v=${version}`
      return this.isfriend
        ? `${this.ImHost}/business/chat/player/playerMultiple.html?role=agent&token=${this.imtoken}&imid=${this.imid}${this.friendid}&apiHost=${this.apiHost}&orderToken=${this.orderToken}&v=${version}`
        : `${this.ImHost}/business/chat/player/playerMultiple.html?role=agent&chatType=0&token=${this.imtoken}&imid=${this.imid}&apiHost=${this.apiHost}&orderToken=${this.orderToken}&v=${version}`;
    }
  },
  mounted() {
    this.getBulletin();
    this.updateBulletin();
    this.updateUserInfo();

    document.body.addEventListener("mouseup", event => {
      console.log(event)
      this.isMouseDown_move = false;
      this.isMouseDown_resize = false;
      document.body.removeEventListener("mousemove", this.attachMove, false);
      this.isShowResize = false;
    });

    this.fullheightOnresize();
  },
  beforeDestroy() {
    document.body.removeEventListener("mouseup");
    if (this.time) {
      clearTimeout(this.time);
      this.time = null;
    }
    if (this.updateBulletin) {
      clearTimeout(this.updateBulletin);
      this.updateBulletin = null;
    }

    if (this.updateUserInfoInterval) {
      clearInterval(this.updateUserInfoInterval);
      this.updateUserInfoInterval = null;
    }
  },
  watch: {
    position(val) {
      const dom = this.$refs["iframeBox"];
      if (val.x != null && val.y != null) {
        dom.style.left = val.x + "px";
        dom.style.top = val.y + "px";
      }
    },
    size(val) {
      const dom = this.$refs["iframeBox"];
      if (val.width != null && val.height != null) {
        dom.style.width = val.width + "px";
        dom.style.height = val.height + "px";
      }
    },
    showServiceIframe() {
      if (!this.showServiceIframe) {
        // window.serviceIframe.imBackParent()
        document
          .getElementById("serviceIframe")
          .contentWindow.postMessage({ type: "imBackParent" }, this.imUrl);
      }
    }
  },
  methods: {
    attachMove(event) {
      if (this.time) return;
      this.move(event);
      this.time = setTimeout(() => {
        this.time = null;
      }, 10);
    },
    mousedown_move(event) {
      this.isMouseDown_move = true;
      this.coordinate.prevx = event.clientX;
      this.coordinate.prevy = event.clientY;

      document.body.addEventListener("mousemove", this.attachMove, false);
    },
    mousedown_resize(event, direction, isX) {
      this.isMouseDown_resize = true;
      this.direction = direction;
      this.resize_isX = isX;
      this.coordinate.prevx = event.clientX;
      this.coordinate.prevy = event.clientY;
      console.log(isX, this.coordinate.prevx, this.coordinate.prevy);
      document.body.addEventListener("mousemove", this.attachMove, false);
    },
    move(event) {
      const dom = this.$refs["iframeBox"];
      // 移动
      if (this.isMouseDown_move) {
        this.$nextTick(() => {
          this.coordinate.curx = event.clientX;
          this.coordinate.cury = event.clientY;

          const distanceX = this.coordinate.curx - this.coordinate.prevx;
          const distanceY = this.coordinate.cury - this.coordinate.prevy;
          const positionX = parseInt(dom.style.left || dom.offsetLeft);
          const positionY = parseInt(dom.style.bottom || dom.offsetTop);

          const x = positionX + distanceX;
          const y = positionY + distanceY;

          this.coordinate.prevx = this.coordinate.curx;
          this.coordinate.prevy = this.coordinate.cury;
          console.log(x, y);
          if (y < 115) {
            this.$message("不可拖到外部");
            this.isMouseDown_move = false;
            return;
          }
          this.position = { x, y };
        });
      }
      // 缩放
      if (this.isMouseDown_resize) {
        this.$nextTick(() => {
          this.coordinate.curx = event.clientX;
          this.coordinate.cury = event.clientY;

          const distanceX =
            this.direction * (this.coordinate.curx - this.coordinate.prevx);
          const distanceY =
            this.direction * (this.coordinate.cury - this.coordinate.prevy);
          const prevWidth = parseInt(dom.style.width || dom.clientWidth);
          const prevHeihgt = parseInt(dom.style.height || dom.clientHeight);

          // y轴移动的多，以y轴为准。否则以x为准,保准等比缩放
          let width, height;

          if (this.resize_isX) {
            width = Math.round(prevWidth + distanceX);
            height = Math.round((width / 4) * 7);
          } else {
            height = Math.round(prevHeihgt + distanceY);
            width = Math.round((height / 7) * 4);
          }

          this.coordinate.prevx = this.coordinate.curx;
          this.coordinate.prevy = this.coordinate.cury;

          console.log(width, height);
          if (width < 240 || width > 600) {
            this.$message("已经到达缩放最大范围！");
            this.isMouseDown_resize = false;
            return;
          }
          this.size = { width, height };
        });
      }
    },
    add() {
      this.showUpdate = true;
    },
    fullheightOnresize() {
      if (this.fullHeight <= 790 && this.fullHeight > 640) {
        this.fullheightclass = "fullheightclass";
      } else if (this.fullHeight <= 640) {
        this.fullheightclass = "fullheightclass1";
      }
      window.onresize = () => {
        return (() => {
          this.fullHeight = document.documentElement.clientHeight;
          if (this.fullHeight <= 790 && this.fullHeight > 640) {
            this.fullheightclass = "fullheightclass";
          } else if (this.fullHeight <= 640) {
            this.fullheightclass = "fullheightclass1";
          } else {
            this.fullheightclass = "";
          }
        })();
      };
    },
    userMessageopen(item) {
      if (item.cid == this.prevCid) return;
      this.prevCid = item.cid;
      this.clickuserMessageBtn();
      console.log("未读消息:" + JSON.stringify(item));
      const h = this.$createElement;
      this.dialogArr.push(
        this.$notify.success({
          title: "提示",
          message: h("p", null, [
            h(
              "a",
              {
                on: {
                  click: this.openService.bind(this, item)
                },
                style: "color: teal"
              },
              `${item.nickname}给您发了一条新的消息`
            ),
            h("br"),
            h(
              "button",
              {
                on: {
                  click: this.openService.bind(this, item)
                },
                class:
                  "el-button el-button--primary el-button--mini float-right"
              },
              "点击查看"
            )
          ]),
          position: "bottom-right",
          duration: 3000
        })
      );
    },
    // 处理未读消息(当前聊天置于0，并发送总未读数量)
    clickuserMessageBtn(msg) {
      // msg存在表示点击查看进入一对一聊天中，然后清空当前未读消息数量。
      if (msg) {
        this.isfriend = true;
      }

      for (var i = 0; i < this.dialogArr.length; i++) {
        this.dialogArr[i].close();
      }
    },
    handleMessage(e) {
      if (this.$store.getters.userinfo.agency_type === 1) {
        let data = e.data;
        if (data.type == "goOffWork") {
          this.$store.dispatch("GetInfo");
        }
        if (data.type == "imStatus") {
          this.imStatus = data.status;
          if (!this.imStatus) {
            this.$message("当前状态已掉线，未连接");
          } else {
            // this.$store.dispatch("GetInfo");
            // console.warn("GetInfo");
          }
        }
        if (data.type == "mouseup") {
          this.isMouseDown_move = false;
          this.isMouseDown_resize = false;
          document.body.removeEventListener(
            "mousemove",
            this.attachMove,
            false
          );
          this.isShowResize = false;
        }
        if (data.unMsgtotal) {
          this.shake = "";
          this.shake = "shake";
          this.unMsgtotal = data.unMsgtotal;
          if (this.showServiceIframe == false) {
            console.log("未读消息:" + JSON.stringify(data.unreadyMsg));
            if (data.unreadyMsg) {
              this.userMessageisopen = true;
              data.unreadyMsg.map(item => {
                if (
                  item.cid != this.prevCid &&
                  item.msgNum != "new" &&
                  item.msgNum != "0"
                ) {
                  // this.isfriend = true
                  this.friendid = "&target_id=" + Number(item.id);
                  console.warn(item);
                  this.userMessageopen(item);
                }
              }, this);
            }
          }
        } else if (data.unMsgtotal == 0) {
          this.unMsgtotal = data.unMsgtotal;
          this.shake = "";
        }
        if (data.closeIm) {
          this.showServiceIframe = false;
          this.isfriend = false;
          this.shake = "";
        }
      }
    },
    // 这是一个定时器
    timefun() {
      return setInterval(() => {
        if (
          this.bulletincount == this.bulletin.length ||
          this.bulletincount + 1 == this.bulletin.length
        ) {
          this.bulletincount = 0;
        } else {
          this.bulletincount += 1;
        }
        this.bulletinTitle = this.bulletin[this.bulletincount].value;
      }, 10000);
    },
    timerbulletin() {
      this.bulletinTitle = this.bulletin[this.bulletincount].value;
      this.bulletincount++;
      clearInterval(this.outTimeFun);
      return (this.outTimeFun = this.timefun());
    },
    getBulletin() {
      getBulletin().then(res => {
        if (res.status === 0) {
          this.bulletincount = 0;
          this.bulletin = res.data;
          if (this.bulletin.length > 0) {
            this.timerbulletin();
          } else {
            this.bulletinTitle = "暂无公告！";
          }
        } else {
          this.bulletinTitle = "暂无公告！";
        }
      });
    },
    // 10分钟更新一次公告
    updateBulletin() {
      this.time_update_bulletin = setInterval(() => {
        this.getBulletin();
      }, 600000);
    },
    // 30 * 5 秒钟更新一次用户信息
    updateUserInfo() {
      var that = this
      this.updateUserInfoInterval = setInterval(() => {
        if (that.imStatus && that.$store.state.user.userinfo.working) {
          that.$store.dispatch("GetInfo");
        }
      }, 30000 * 5);
    },
    togWorking(value) {
      if (value) {
        if (this.$store.state.user.userinfo.balance / 100 < 2000) {
          this.$message({
            message: "无法上班，当前余额不足2000!",
            type: "warning"
          });
        } else if (this.$store.state.user.userinfo.receipt_address_count == 0) {
          this.$message({
            message: "无法上班，当前无可用收款账号!",
            type: "warning"
          });
        } else {
          gotoWork().then(res => {
            if (res.status === 0) {
              this.$store.dispatch("GetInfo");
            }
          });
        }
      } else {
        gooffWork().then(res => {
          if (res.status === 0) {
            this.$store.dispatch("GetInfo");
          }
        });
      }
    },
    openService() {
      this.clickuserMessageBtn.apply(this, arguments);
      this.showServiceIframe = !this.showServiceIframe;
      if (!this.showServiceIframe || arguments[0] == null) {
        this.isfriend = false;
      }
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.margin-auto-top {
  line-height: 80px;
  height: 80px;
  font-size: 14px;
  /*min-width: 918px;*/
  overflow: hidden;

  .el-col {
    margin: 0px;
  }

  .user-photo {
    height: 80px;
    display: inline-block;
    float: left;

    img {
      margin-left: 10px;
      border-radius: 50%;
      padding: 5px;
    }
  }

  .user-working {
    height: 40px;
    float: left;
    overflow: hidden;
    line-height: 40px;
    width: 100%;
    text-align: center;
  }

  .user-userinfo-div1 {
    display: inline-block;
    line-height: 80px;
    width: 140px;
    height: 80px;
  }

  .user-nickname {
    display: inline-block;
    height: 40px;
    float: left;
    line-height: 50px;
    width: 100%;
    text-align: center;
  }

  .user-wechat {
    /*display: inline-block;*/
    /*float: left;*/
    height: 80px;
    text-align: center;
    /*width: 85%;*/
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 30px;
      line-height: 30px;
      &.center {
        height: 20px;
        line-height: 20px;
      }
      &.text-left {
        text-align: left;
        margin-left: 20%;
      }
      .bulletin {
        padding: 4px;
        border: none;
        font-size: 18px;
      }
    }
  }
}

.navbar {
  height: 80px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .service {
    z-index: 1002;
    position: absolute;
    right: 160px;
    top: 0px;
    background: white;
    height: 78px;
    line-height: 95px;
    .workoff {
      .el-badge__content {
        color: #f00;
      }
    }
    .el-button.is-circle {
      font-size: 35px;
      padding: 8px;
    }
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    z-index: 1001;
    height: 78px;
    display: inline-block;
    right: 35px;
    position: absolute;
    top: 0;
    background: white;
    padding-left: 10px;

    .avatar-wrapper {
      cursor: pointer;
      position: relative;

      .user-avatar {
        width: 109px;
        height: 80px;
        border-radius: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        text-align: right;
      }

      .el-icon-arrow-down {
        float: right;
        height: 80px;
        line-height: 80px;
      }
    }
  }

  .serviceIframe {
    position: fixed;
    right: 10px;
    bottom: 20px;
    z-index: 91011;
    // border: solid #00ff8b 2px;
    box-shadow: 0px 0px 8px #ccc;

    // 开启硬件加速
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;

    -webkit-perspective: 1000;
    -moz-perspective: 1000;
    -ms-perspective: 1000;
    perspective: 1000;
    .drag {
      position: absolute;
      left: 16%;
      top: 0;
      z-index: 91012;
      background: transparent;
      width: 70%;
      height: 30px;
      cursor: move;
    }
    .resize-icon {
      position: absolute;
      width: 14px;
      height: 14px;
      border: 1px solid #777;
      background: transparent;
      z-index: 91012;
      cursor: pointer;
      border-radius: 50%;
    }
    .resize-icon-top-left {
      left: -20px;
      top: -20px;
    }
    .resize-icon-top-right {
      right: -20px;
      top: -20px;
    }
    .resize-icon-bottom-left {
      bottom: -20px;
      left: -20px;
    }
    .resize-icon-bottom-right {
      bottom: -20px;
      right: -20px;
    }
  }

  .fullheightclass {
    top: 80px;
    height: 85%;
  }

  .fullheightclass1 {
    top: 80px;
    height: 80%;
  }
}

@-webkit-keyframes shake {
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translateX(-10px);
  }
  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translateX(10px);
  }
}

@-moz-keyframes shake {
  0%,
  100% {
    -moz-transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    -moz-transform: translateX(-10px);
  }
  20%,
  40%,
  60%,
  80% {
    -moz-transform: translateX(10px);
  }
}

.item.shake {
  -webkit-animation-name: shake;
  -webkit-animation-duration: 1s;
  -moz--name: shake;
  -moz-animation-duration: 1s;
}
</style>

